import { faPause, faPlay } from "@fortawesome/pro-solid-svg-icons";
import { Box, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

import { Icon, Typography } from "../../components/ui-v2";

const Container = styled(Stack)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  padding: theme.spacing(3),
  paddingTop: 0,
}));

const HeaderContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
}));

const IconContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  cursor: "pointer",
  color: theme.palette.secondary[3],
  "&:hover": {
    color: theme.palette.secondary[2],
  },
}));

interface AnimationControlsProps {
  rotate: boolean;
  onToggleRotation: () => void;
}

export const AnimationControls = (props: AnimationControlsProps) => {
  const { rotate, onToggleRotation } = props;

  return (
    <Container gap={2}>
      <HeaderContainer>
        <Typography color="secondary.2" variant="regular">
          Animation
        </Typography>
      </HeaderContainer>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography color="secondary.2" variant="small">
          Auto-rotate
        </Typography>
        <IconContainer onClick={onToggleRotation}>
          {rotate ? (
            <Icon size="medium" icon={faPause} />
          ) : (
            <Icon size="medium" icon={faPlay} />
          )}
        </IconContainer>
      </Box>
    </Container>
  );
};
